import { getCdn } from "utils";

const Icon = ({
	icon = null,
	className = "",
	rotate = false,
	title = null,
	loading = "lazy",
	brand = "",
	onClick = null,
	color = "",
	ariaHidden = null
}) => {
	let iconClass = "syndicated-icon";
	if (icon) iconClass += ` syndicated-icon--${icon}`;
	if (rotate) iconClass += ` syndicated-icon--rotate`;
	if (className) iconClass += ` ${className}`;
	if (brand) iconClass += ` syndicated-icon--${brand}`;
	if (color) iconClass += ` syndicated-icon--no-filter`;

	const iconUrl = `${getCdn(true)}/icons/pep/${icon}${
		color ? `--${color}` : ""
	}.svg`;

	if (!icon) {
		return null;
	}

	return (
		<img
			alt={title || ""}
			title={title}
			className={iconClass}
			src={iconUrl}
			loading={loading}
			onClick={onClick}
			aria-hidden={ariaHidden}
		/>
	);
};

export default Icon;
